import { render } from "./AdminOrders.vue?vue&type=template&id=dcb53e32&ts=true"
import script from "./AdminOrders.vue?vue&type=script&lang=ts"
export * from "./AdminOrders.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__